import { SvgIcon, SvgIconProps } from '@mui/material';

export interface CcfCopilotDisikedIcon extends SvgIconProps {
  fillColor?: string;
}
/**
 * Component displays copilot dislike Icon
 * @param props -SvgIconProps
 * @returns copilot dislike svg icon
 * @example <CcfCopilotDislikeIcon/>
 */
export function CcfCopilotDislikedIcon(props: CcfCopilotDisikedIcon) {
  return (
    <SvgIcon {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.576 17.1147C10.3312 17.6531 9.78504 18 9.18235 18C7.58012 18 6.28126 16.7304 6.28126 15.1643V12.2727H3.34893C1.29686 12.2727 -0.272379 10.4848 0.0396538 8.50236L0.941095 2.77508C1.19238 1.17854 2.59779 0 4.25037 0H15.4888C16.8757 0 18 1.09894 18 2.45455V8.18182C18 9.53743 16.8757 10.6364 15.4888 10.6364H13.5217L10.576 17.1147ZM16.3259 5.75L13.8147 1.63636H15.4888C15.9511 1.63636 10.5 1 16.3259 2.45455L13.5 1.5C13.5 1.95187 14.9722 2.77508 14.5099 2.77508L16.3259 5.75Z"
          fill="#007AB8"
        />
      </svg>
    </SvgIcon>
  );
}

export default CcfCopilotDislikedIcon;
